var fullProductList = false;

// On the cart page pass in the recipient name stored in data-recipientname and retrieve a comma separated string of the handles for all products purchased as gifts for this recipient. Add this string as a query to the end of the url sent to the gift recipient linking to the Recipient Landing Page
function buildRecipientLanding(recipient){
  var ids = $('[data-recipientname="'+ recipient + '"]')
  var url_ids = ids.map(function(i, id){
    var product = $(id).data('productid')
    return product
  }).toArray()

  return url_ids.toString()
}

// Used to empty the cart if nothing is left in it except for Notification Cards
function clearCart() {
  $.ajax({
     type: 'POST', 
     url: '/cart/clear.js',
     dataType: 'json', 
     success: function(res){
      console.log('cart cleared', res);
     },
     error: function(){
      console.log('err');
     }
  })
}

//Request to get each product that is part of the Recipient collection (use string obtained in recipientProductString)
function getRecipientProducts(product_ids){
  $.ajax({
     type: 'GET', 
     url: '/products.json?ids=' + product_ids,
     dataType: 'json', 
     success: function(res){
      buildPurchaseCollection(res);
      if(fullProductList === false) {
        buildProduct(res);
      }
      productFilter($.extend({}, fullProductList), '+', 'all');
      
     },
     error: function(){
      console.log('err');
     }
  });
}

// On the recipient landing page use this to retrieve the product handles from the end of the url. q is the query (ex. recipienthandles=moderately-expensive-product,30-one-time-donation, recipienthandles should be passed in)
function recipientProductString(q){
  var url = window.location.href
  q = q.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + q + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);    
  if (!results){return null} ;
  if (!results[2]){return ''};
  return decodeURIComponent(results[2].replace(/\+/g, " "));
  
}
// filter product based on type
function filterProductsOriginal(collection_id, type, product_id, limit){
  console.log("filterProductsOriginal");
  collection_id ? collection_id = 'collection_id=' + collection_id : collection_id = ''
  type && type != 'all' ? type = 'product_type=' + type : type = ''
  $.ajax({
    type: 'GET',
    url: '/admin/products.json?' + collection_id + '&' + type,
    dataType: 'json',
    success: function(res){
      if (product_id){
        new_res = $.grep(res.products, function(e){
             return e.id != product_id;
          });
        final_res = {};
        final_res.products = new_res
      } else {
        final_res = res
      }
      if(limit){
        buildProduct(final_res, limit)
      } else {
        buildProduct(final_res)
      }
    },  
    error: function(status){
      console.log('err')
      console.log(status)
     }
  });
}

function handleFilteredPrices() { 
  
  //console.log('handleFilteredPrices');
  
  $('.price').each(function() {
    
    var thisPrice = $(this).text();
    $(this).html(thisPrice); 
    
  });
  
}

function filterProducts(opts){
  //console.log("filterProducts");
  if(typeof opts.excludeTypes == "undefined" || !(opts.excludeTypes instanceof Array)) {
    opts.excludeTypes = [];
  }
  
  
  if(fullProductList === false) {
    fullProductList = [];
    $.ajax({
      type: 'GET',
      url: '/products.json?limit=100', // without the limit parameter, you only get 30 products back.
      dataType: 'json',
      success: function(res){
        //console.log("success");
        buildProduct(res.products);
        productFilter($.extend({}, fullProductList), opts.type, opts.sort, opts.excludeTypes);
        
        if(typeof timber.handleBlocks !== "undefined"){
          timber.handleBlocks();
        }
        
        handleFilteredPrices();
      },
      error: function(status){

      }
    });
  } else if(fullProductList.length) {
    productFilter($.extend({}, fullProductList), opts.type, opts.sort, opts.excludeTypes);
    if(typeof timber.handleBlocks !== "undefined"){
      timber.handleBlocks();
    }
    handleFilteredPrices();
  }
}
function productFilter(products, type, sort, excludeTypes){
  var $productContainer = $('#js-product-container');
  var data = {},
      source = $("#ProductTemplate").html(),
      template = Handlebars.compile(source);
  var filtered_products = [];
  $.each(products, function(i, product){
    //console.log('product_type: ' + product.type);
    //console.log('filter type: ' + type);
    /*if(typeof price == 'string'){
      if(price.charAt(0) == '+' && type != 'all'){
        n_price = price.substring(1) 
        product.variants[0].price > parseInt(n_price) && product.type == type ? filtered_products.push(product) : null 
      }else if(price.charAt(0) == '+' && type == 'all') {
       n_price = price.substring(1) 
       product.variants[0].price > parseInt(n_price) ? filtered_products.push(product) : null 
      }
    }else{*/   
      /*if(price && type!='all'){
        // if both a price and type filter are selected
        product.variants[0].price < parseInt(price) && product.type == type ? filtered_products.push(product) : null
      }else if(price && type == 'all') {
        // if only a price filter is selected
        product.variants[0].price < parseInt(price) ? filtered_products.push(product) : null
      } else*/ 
      if(type != 'all' && excludeTypes.indexOf(product.type) < 0){
        // if only a type filter is selected
        product.type == type ? filtered_products.push(product) : null
      } else if (type == 'all' && excludeTypes.indexOf(product.type) < 0) {
        filtered_products.push(product);
      }
    //}
    
  });
  /*if (product_id){
    new_res = $.grep(filtered_products, function(e){
         return e.id != product_id;
      });
    final_res = {};
    if(limit) {
      new_res = new_res.slice(0, limit);
    }
    final_res.products = new_res;
  } else {*/

    var sortComponents = sort.split('-');
    //console.log(sort, sortComponents);
    if(sortComponents.length > 1) {
      var opts = {
        'sortBy': sortComponents[0],
        'order': sortComponents[1],
      }
      if(sortComponents[0] == "price") {
        opts.filterValue = function(value) {
          return parseFloat(value.replace(/[^0-9\.]/gi, ''));
        }
      }
      final_res = productSort(filtered_products, opts);
    } else {
      final_res = filtered_products;
    }
    
    /*if(limit) {
      final_res = final_res.slice(0, limit);
    }*/
  //}
  $productContainer.empty();
  data = {
   products: final_res
  };
  $productContainer.append(template(data));
  /*if(limit){
    buildProduct(final_res, limit)
  } else {
    buildProduct(final_res)
  }*/
}

function productSort(products, opts) {
  if(typeof opts.order == "undefined") {
    opts.order = 'ascending';
  }
  if(typeof opts.filterValue !== "function") {
    opts.filterValue = function(value) { return value; };
  }
  for (var i = 0; i < products.length; i++) {
    if(typeof products[i][opts.sortBy] == "undefined") {
      products[i][opts.sortBy] = null;
    }
    for (var j = i; j > 0; j--) {
      switch(opts.order.toLowerCase()) {
        case 'ascending':
          if(opts.filterValue(products[j-1][opts.sortBy]) > opts.filterValue(products[j][opts.sortBy])){
             var temp = products[j-1];
             products[j-1] = products[j];
             products[j] = temp;
          }
        break;
        case 'descending':
          if(opts.filterValue(products[j-1][opts.sortBy]) < opts.filterValue(products[j][opts.sortBy])){
             var temp = products[j-1];
             products[j-1] = products[j];
             products[j] = temp;
          }
        break;
      }
    }
  }
  return products;
}

// add one time donation
function addOneTimeDonation(form_id, button) {
  var quantity = parseInt($('#'+form_id).siblings('#Quantity').val());
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: 'id=' + $('#'+form_id).val() + '&quantity=' + quantity,
    success: function(res){
      $(button).html('Article Ajouté!');
      getCart(buildCart);
      addToCartOk(quantity);
      location.reload();
    },
    error: addToCartFail
  });
}

// add item 
function addItem(form_id, button) {
  $(button).html('Ajout en cours...');
  //console.log($('#'+form_id).serialize())
  var quantity = parseInt($('#'+form_id).find('#Quantity').val());
  $.ajax({
    type: 'POST', 
    url: '/cart/add.js',
    dataType: 'json', 
    data: $('#'+form_id).serialize(),
    success: function(res){
      $(button).html('Article Ajouté!');
      getCart(buildCart)
      addToCartOk(quantity)
    },
    error: addToCartFail
  });
}

// add suggested item on cart page
function addSuggestedItem(variant_id, button) {
  $(button).val('Ajout en cours...');
  var quantity = 1
  var data = 'id='+ variant_id + '&quantity=1' 
   $.ajax({
      type: 'POST', 
      url: '/cart/add.js',
      dataType: 'json', 
      data: data,
      success: function(){
        $(button).val('Article Ajouté!');
        getCart(buildCart);
        addToCartOk(quantity);
      },
      error: addToCartFail
   });
}

function queueCartItems(){

}
// purchase all
function addAllItems(array, button){
  $(button).attr('disabled', true);
  $(button).html('Ajout en cours...');
  Shopify.queue = [];
  var quantity = 0;
  var newArray = array.split(',');
  for (var i = 0; i < newArray.length; i++) {
    product = newArray[i]
    Shopify.queue.push({
      variantId: product,
      quantity: 1
    });
  }
  Shopify.moveAlong = function() {
    // If we still have requests in the queue, let's process the next one.
    if (Shopify.queue.length) {
      var request = Shopify.queue.shift();
      var data = 'id='+ request.variantId + '&quantity=1'
       $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          dataType: 'json',
          data: data,
          success: function(res){
              Shopify.moveAlong();
              quantity += 1;
          },
          error: addToCartFail
       });
    }
    // If the queue is empty, we will build the cart
    else {
      quantity += 1;
      getCart(buildCart);
      addToCartOk(quantity);
      $(button).attr('disabled', false);
      $(button).html('Article Ajouté!');
    }
  };
  Shopify.moveAlong();

}


function getQuantity(id){
  var quantity = $('#updates_' + id).val()
  var current_quantity = $('#updates_' + id).attr('value')
  var diff = quantity - current_quantity
  $('#updates_' + id).attr('value', quantity)
  //console.log('#######');
  //console.log(id);
  changeQuantity(quantity, id, diff)
}
function changeQuantity(quantity, id, diff){
  //console.log("CHANGING QUANTITY");
  $.ajax({
     type: 'POST', 
     url: '/cart/change.js',
     dataType: 'json', 
     data: 'quantity='+ quantity + '&id=' + id ,
     success: function(data){
        buildCart(data)
        updateCartCount(data, diff)
     },
     error: addToCartFail
  });
}

function updateCartCount(data, diff){
  cartCount += diff
  $('#js-cart-number').replaceWith('<span class="cart-number" id="js-cart-number">' + cartCount + '</span>');
  $('.site-nav--mobile #js-cart-number').replaceWith('<span class="cart-number" id="js-cart-number">' + cartCount + '</span>');
}

function addToCartOk(quantity) {
  //console.log("add to cart ok");
  $('.nav-link--cart, .site-nav--mobile').removeClass("cart-icon-empty");
  cartCount += quantity;  
  $('#js-cart-number').replaceWith('<span class="cart-number" id="js-cart-number">' + cartCount + '</span>');
  $('.site-nav--mobile #js-cart-number').replaceWith('<span class="cart-number" id="js-cart-number">' + cartCount + '</span>');
  // buildCart(cart);
  
  // handleHiddenItems();
} 

function addToCartFail(obj, status) { 
  console.log('error')
  console.log(obj, status, 'err')
}

// build cart quick view
function buildCart(cart){
  var $cartContainer = $('#cart-container')
  $cartContainer.empty()
  if (cart.item_count === 0) {
    $cartContainer
      .append('<p class="cart-quick-view empty">there are currently no items in the cart</p>');
    return;
  } 
 var items = [],
     item = {},
     data = {},
     source = $("#CartTemplate").html(),
     template = Handlebars.compile(source),
     money_format = Shopify.money_format;
  
  // Remove Notification Cards from displaying in the cart
  var cartItems = cart.items.filter(function (item) {
            return item.product_type !== "Notification Cards"
          });

  $.each(cartItems, function(index, cartItem) {
    // Create item's data object and add to 'items' array
    item = {
      id: cartItem.variant_id,
      line: index + 1, // Shopify uses a 1+ index in the API
      url: cartItem.url,
      name: cartItem.product_title,
      variation: cartItem.variant_title,
      properties: cartItem.properties,
      itemQty: cartItem.quantity,
      itemImg: cartItem.image,
      price: Shopify.formatMoney(cartItem.price, money_format),
      vendor: cartItem.vendor
    };

    items.push(item);
  });   

  data = {
    items: items,
    totalPrice: Shopify.formatMoney(cart.total_price, money_format),
    quantityLabel: "Quantité",
    viewLabel: "Visualiser",
    moneyClass: ( $('body').hasClass('site-french') ? 'french-money' : '' )
  } 

  $cartContainer.append(template(data));

//  if there are items in the cart
  if (cartItems.length > 0) {
      //console.log('checking cart');
     //  for each price item in the quick view
     $('.cart-preview--price').each(function() { 
       var $this = $(this);
       // need to use different variables because french site prices are wrapped in span
       if($('body').hasClass('site-french')) {
         var thisPrice = $this.find('span');
       } else {
         var thisPrice = $this;
       }
       
       // get text value of price
       var priceText = thisPrice.text();
       
       // get length of price text
       var priceLength = priceText.length;
       
       // if price text is long
       if(priceLength > 9) {
         // change font size to smaller so it will fit
         thisPrice.css({
           fontSize: "16px"
         });
       } else if(priceLength > 7) {
         thisPrice.css({
           fontSize: "19px"
         });
       }
    });
  } 
}

function buildProduct(res){
  var products = [],
      product = {}, 
      money_format = Shopify.money_format;
  $.each(res, function(index, productItem) {
    //console.log("productItem", productItem);
    var description = ($('#js-add-to-cart-'+productItem.id).closest('.block-action').siblings('.block-description').length ?
      $('#js-add-to-cart-'+productItem.id).closest('.block-action').siblings('.block-description').text() :
      productItem.body_html.replace(/<\/?[^>]+(>|$)/g, "").split(' ').splice(0, 25).join(' '));
    var windowUrl = window.location.href;
    var productDir = productItem.handle;
    
    var featuredImg = ($('#js-add-to-cart-'+productItem.id).closest('.block-content').siblings('a').find('.block-header').length ?
      $('#js-add-to-cart-'+productItem.id).closest('.block-content').siblings('a').find('.block-header').css('background-image').replace(/(url\()|(\))|(\")/gi, '') :
      (productItem.images.length ? productItem.images[0].src : ''));

    //console.log(featuredImg, $('#js-add-to-cart-'+productItem.id).closest('.block-content').siblings('a').find('.block-header'));
    // Create item's data object and add to 'items' array
    product = {
      type: productItem.product_type,
      title: productItem.title, 
      price: Shopify.formatMoney(productItem.variants[0].price, money_format),
      featuredImg: featuredImg, //productItem.images[0].src,
      productUrl: windowUrl.replace("collections/all", "products/" + productDir),
      description: description,
      id: productItem.id, 
      compare_at_price: Shopify.formatMoney(productItem.variants[0].compare_at_price, money_format),
      sale: productItem.variants[0].price > productItem.variants[0].compare_at_price, 
      variants: productItem.variants
    };
    
    fullProductList.push(product);

  }); 

}

//build purchase entire collection block with handlebars template
function buildPurchaseCollection(res){
  var $collectionPurchaseContainer = $('#js-collection-purchase-container');
  $collectionPurchaseContainer.empty();
  var data = {}, 
      source = $("#PurchaseCollectionTemplate").html(),
      template = Handlebars.compile(source);
      money_format = Shopify.money_format,
      price = 0
  $.each(res.products, function(index, productItem) {
    price += productItem.variants[0].price    
  });
  data = {
    price: Shopify.formatMoney(price, money_format)
  }
   $collectionPurchaseContainer.append(template(data))
}

function getCart(callback) {

  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    
    }
  });
};
